import { Controller } from "@hotwired/stimulus"

// Live countdown for a checked-out chore. Renders the time remaining until the
// 12-hour window expires, based on a server-provided ISO expiry timestamp.
export default class extends Controller {
  static targets = ["display"]
  static values = { expiresAt: String }

  connect() {
    this.endTime = new Date(this.expiresAtValue).getTime()
    this.tick()
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  tick() {
    const remaining = this.endTime - Date.now()

    if (remaining <= 0) {
      this.displayTarget.textContent = "Expired — resetting soon"
      this.element.classList.add("text-danger")
      return
    }

    const totalSeconds = Math.floor(remaining / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    const pad = (n) => String(n).padStart(2, "0")

    this.displayTarget.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)} left`

    // Warn (amber) in the final hour.
    this.element.classList.toggle("text-warning", remaining < 3600 * 1000)

    this.timeout = setTimeout(() => this.tick(), 1000)
  }
}
